module.exports = __webpack_public_path__ + "img/info-4.0813d33a.svg";